module.exports = __webpack_public_path__ + "img/lots.5407ef03.svg";